export default {
	init() {
		// JavaScript to be fired on all pages

		// Navigation Toggle
		this.initNavigation();

		// AJAX Modal Content Loading
		this.initDynamicModal();

		// Static Modal System
		this.initStaticModals();

		// Central URL param coordinator - handles opening order
		this.initURLParamHandler();

		// Page loader
		this.initPageLoader();

		function sk8_disableOrphanedSubnavLinks() {
			document.querySelectorAll('.subnav a[href^="#"]').forEach(link => {
				const target = link.getAttribute('href').slice(1);
				if (target && !document.getElementById(target)) {
					link.classList.add('is-disabled');
				}
			});
		}

		sk8_disableOrphanedSubnavLinks();
	},

	initNavigation() {
		const navToggle = document.getElementById('nav-toggle');
		const navPrimary = document.getElementById('nav-primary');

		if(!navToggle || !navPrimary) return;

		navToggle.addEventListener('click', (e) => {
			e.preventDefault();
			const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
			navToggle.setAttribute('aria-expanded', String(!isExpanded));
			navToggle.classList.toggle('is-active');
			navPrimary.classList.toggle('is-active');
		});

		navPrimary.addEventListener('click', (e) => {
			// Close menu when clicking any link (subnav or main)
			const clickedLink = e.target.closest('a');
			if(clickedLink) {
				navToggle.setAttribute('aria-expanded', 'false');
				navToggle.classList.remove('is-active');
				navPrimary.classList.remove('is-active');
			}
		});
	},

	initDynamicModal() {
		const dynamicModal = document.getElementById('modal-dynamic');
		if(!dynamicModal) return;

		const modalTitle = dynamicModal.querySelector('.op-modal-title');
		const modalBody = dynamicModal.querySelector('.op-modal-body');

		if(!modalTitle || !modalBody) {
			console.warn('Dynamic modal missing title or body elements');
			return;
		}

		const loaderHTML = modalBody.innerHTML; // Preserve initial loader state

		// Load modal content via AJAX
		const loadModalContent = (type, postId, postSlug = null, fallbackUrl = null, pushState = true) => {
			// Validate inputs
			if(!type || !postId) {
				console.error('loadModalContent requires type and postId');
				return;
			}

			// Open modal with loader
			modalTitle.textContent = 'Loading...';
			modalBody.innerHTML = loaderHTML;

			try {
				dynamicModal.showModal();
				// Trigger reflow and add is-open class for transition
				void dynamicModal.offsetHeight;
				dynamicModal.classList.add('is-open');
			} catch(error) {
				console.error('Error opening dynamic modal:', error);
				return;
			}

			// Update URL if pushState is enabled
			if(pushState && postSlug) {
				const url = new URL(window.location);
				// Remove all existing sk8nigs-* parameters first
				const urlParams = new URLSearchParams(url.search);
				for(const key of Array.from(urlParams.keys())) {
					if(key.startsWith('sk8nigs-')) {
						urlParams.delete(key);
					}
				}
				url.search = urlParams.toString();
				// Use slug in URL (readable), store postId in history state
				url.searchParams.set(`sk8nigs-${type}`, postSlug);

				// Store modal data in history state
				// Preserve originalTitle from previous state, or capture current title
				const originalTitle = history.state?.originalTitle || document.title;

				try {
					history.pushState({
						modalType: 'dynamic',
						type: type,
						postId: postId,
						slug: postSlug,
						originalTitle: originalTitle
					}, '', url);
				} catch(error) {
					console.error('Error pushing history state:', error);
				}
			}

			// Fetch content based on type
			const endpoint = `/wp-json/sk8nigs/v1/${type}/${postId}`;

			fetch(endpoint)
			.then(response => {
				if(!response.ok) {
					throw new Error(`HTTP ${response.status}: Content not found`);
				}
				return response.json();
			})
			.then(data => {
				if(data.success) {
					modalTitle.textContent = data.title || 'Untitled';
					modalBody.innerHTML = data.content || '';

					// Update document title with type prefix
					if(data.title) {
						const typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
						document.title = `${typeLabel}: ${data.title}`;
					}
				} else {
					throw new Error('Invalid response format');
				}
			})
			.catch(error => {
				console.error('Modal fetch error:', error);
				try {
					dynamicModal.close();
				} catch(e) {
					console.error('Error closing modal:', e);
				}

				// Redirect to fallback URL if available
				if(fallbackUrl) {
					window.location.href = fallbackUrl;
				}
			});
		};

		// Event delegation for AJAX modal triggers
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('[data-modal-ajax]');
			if(!trigger) return;

			e.preventDefault();
			const type = trigger.dataset.modalAjax;
			const postId = trigger.dataset.postId;
			const postSlug = trigger.dataset.postSlug;
			const fallbackUrl = trigger.href;

			if(!type || !postId) {
				console.warn('Modal trigger missing required data attributes');
				return;
			}

			loadModalContent(type, postId, postSlug, fallbackUrl);
		});

		// Handle modal close - remove URL parameter
		const closeModal = () => {
			// Scroll to top to prevent jump when closing
			dynamicModal.scrollTop = 0;

			// Restore original page title if we have it in state
			if(history.state?.originalTitle) {
				document.title = history.state.originalTitle;
			}

			// Remove is-open class to trigger closing transition
			dynamicModal.classList.remove('is-open');

			// Wait for transition, then actually close
			setTimeout(() => {
				try {
					dynamicModal.close();
				} catch(error) {
					console.error('Error closing modal:', error);
				}
			}, 300); // Match CSS transition duration

			// Remove sk8nigs-* parameter from URL
			const url = new URL(window.location);
			const urlParams = new URLSearchParams(url.search);
			let foundParam = false;

			for(const key of Array.from(urlParams.keys())) {
				if(key.startsWith('sk8nigs-')) {
					urlParams.delete(key);
					foundParam = true;
				}
			}

			if(foundParam) {
				url.search = urlParams.toString();
				// Push new state WITHOUT originalTitle - we're back at the base page
				try {
					history.pushState({}, '', url);
				} catch(error) {
					console.error('Error updating history:', error);
				}
			}
		};

		const closeBtn = dynamicModal.querySelector('.modal-close, .op-modal-close');
		if(closeBtn) {
			closeBtn.addEventListener('click', closeModal);
		}

		// Close on backdrop click
		dynamicModal.addEventListener('click', (e) => {
			if(e.target === dynamicModal) {
				closeModal();
			}
		});

		// Close on Escape (native dialog behavior, but we need to clean URL)
		dynamicModal.addEventListener('close', () => {
			// Only clean URL if modal was actually open
			if(dynamicModal.hasAttribute('open')) return;

			const url = new URL(window.location);
			const urlParams = new URLSearchParams(url.search);
			let foundParam = false;

			for(const key of Array.from(urlParams.keys())) {
				if(key.startsWith('sk8nigs-')) {
					urlParams.delete(key);
					foundParam = true;
				}
			}

			if(foundParam) {
				url.search = urlParams.toString();
				try {
					history.replaceState({}, '', url);
				} catch(error) {
					console.error('Error updating history:', error);
				}
			}
		});

		// Handle browser back/forward buttons
		window.addEventListener('popstate', (e) => {
			// First check if we have state data from pushState
			if(e.state?.modalType === 'dynamic' && e.state.type && e.state.postId) {
				// Load modal using data from history state
				loadModalContent(e.state.type, e.state.postId, e.state.slug, e.state.fallbackUrl, false);
				return;
			}

			// Fallback: check URL params (for direct page loads with params)
			const urlParams = new URLSearchParams(window.location.search);
			let foundModal = false;

			for(const [key, value] of urlParams.entries()) {
				if(key.startsWith('sk8nigs-')) {
					const type = key.replace('sk8nigs-', '');
					const slug = value;

					// Try to find trigger in DOM
					const trigger = document.querySelector(`[data-modal-ajax="${type}"][data-post-slug="${slug}"]`);
					if(trigger) {
						const postId = trigger.dataset.postId;
						const fallbackUrl = trigger.href;
						loadModalContent(type, postId, slug, fallbackUrl, false);
						foundModal = true;
						break;
					} else {
						console.warn(`No trigger found for ${type}:${slug}, modal cannot be opened`);
					}
				}
			}

			// Close modal if no modal should be shown
			if(!foundModal) {
				try {
					dynamicModal.close();
				} catch(error) {
					// Modal might already be closed
				}

				// Restore original title if we have it in current state
				if(e.state?.originalTitle) {
					document.title = e.state.originalTitle;
				}

				// Clean up any lingering sk8nigs-* params
				const currentParams = new URLSearchParams(window.location.search);
				let hasModalParam = false;

				for(const key of currentParams.keys()) {
					if(key.startsWith('sk8nigs-')) {
						hasModalParam = true;
						break;
					}
				}

				if(hasModalParam) {
					const cleanUrl = new URL(window.location);
					const cleanParams = new URLSearchParams(cleanUrl.search);

					for(const key of Array.from(cleanParams.keys())) {
						if(key.startsWith('sk8nigs-')) {
							cleanParams.delete(key);
						}
					}

					cleanUrl.search = cleanParams.toString();
					try {
						history.replaceState({}, '', cleanUrl);
					} catch(error) {
						console.error('Error cleaning history:', error);
					}
				}
			}
		});

		// Expose loadModalContent for central URL param coordinator
		this.loadModalContent = loadModalContent;
	},

	initStaticModals() {
		const modals = document.querySelectorAll('.op-modal');
		if(modals.length === 0) return;

		modals.forEach(modal => {
			// Close button
			const closeBtn = modal.querySelector('.modal-close, .op-modal-close');
			if(closeBtn) {
				closeBtn.addEventListener('click', () => {
					try {
						modal.close();
					} catch(error) {
						console.error('Error closing modal:', error);
					}
				});
			}

			// Backdrop click
			modal.addEventListener('click', (e) => {
				if(e.target === modal) {
					try {
						modal.close();
					} catch(error) {
						console.error('Error closing modal:', error);
					}
				}
			});
		});

		// Modal triggers
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('[data-modal]');
			if(!trigger) return;

			e.preventDefault();
			const modalId = trigger.dataset.modal;
			const targetModal = document.getElementById(modalId);

			if(!targetModal) {
				console.warn(`Modal "${modalId}" not found`);
				return;
			}

			try {
				targetModal.showModal();
			} catch(error) {
				console.error(`Error opening modal "${modalId}":`, error);
			}
		});
	},

	initURLParamHandler() {
		// Central coordinator for URL params on page load
		// Ensures proper opening order: modals first, viewer last (viewer always on top)

		// FIRST: Check if we have history state (persists on refresh!)
		// This handles modal navigation - state has postId even if trigger not in DOM
		if(history.state?.modalType === 'dynamic' && history.state.type && history.state.postId) {
			if(this.loadModalContent) {
				this.loadModalContent(
					history.state.type,
					history.state.postId,
					history.state.slug,
					null,
					false
				);
			}

			// Also check for viewer
			const urlParams = new URLSearchParams(window.location.search);
			if(urlParams.has('sk8nigs-viewer') && window.viewerInstance) {
				const viewerId = urlParams.get('sk8nigs-viewer');
				requestAnimationFrame(() => {
					window.viewerInstance.open(viewerId, false);
				});
			}
			return;
		}

		// FALLBACK: Check URL params and find triggers in DOM
		// This handles direct page loads with URL params (no history state)
		const urlParams = new URLSearchParams(window.location.search);

		// Collect what needs to be opened
		let modalToOpen = null;
		let viewerToOpen = null;

		for(const [key, value] of urlParams.entries()) {
			if(key === 'sk8nigs-viewer') {
				viewerToOpen = value;
			} else if(key.startsWith('sk8nigs-')) {
				const type = key.replace('sk8nigs-', '');
				modalToOpen = { type, slug: value };
			}
		}

		// Open in priority order: modal first, then viewer
		// This ensures viewer is ALWAYS on top if both exist

		if(modalToOpen && this.loadModalContent) {
			// Try to find trigger to get additional data
			const trigger = document.querySelector(
				`[data-modal-ajax="${modalToOpen.type}"][data-post-slug="${modalToOpen.slug}"]`
			);

			if(trigger) {
				const postId = trigger.dataset.postId;
				const fallbackUrl = trigger.href;
				this.loadModalContent(modalToOpen.type, postId, modalToOpen.slug, fallbackUrl, false);
			} else {
				console.warn(`No trigger found for ${modalToOpen.type}:${modalToOpen.slug}`);
			}
		}

		if(viewerToOpen && window.viewerInstance) {
			// Open viewer after modal (if modal exists)
			// Use requestAnimationFrame to ensure it opens after modal is fully opened
			requestAnimationFrame(() => {
				window.viewerInstance.open(viewerToOpen, false);
			});
		}
	},

	finalize() {
		// JavaScript to be fired on all pages, after init JS is fired

		// Ticker Animation
		this.initTicker();
	},

	initTicker() {
		const ticker = document.getElementById('ticker');
		if(!ticker) return;

		const track = ticker.querySelector('.sk8nigs__ticker-track');
		if(!track) return;

		const setupAnimation = () => {
			const trackWidth = track.scrollWidth / 2;
			if(trackWidth === 0) return; // Avoid division by zero

			const speed = 80;
			const duration = trackWidth / speed;

			track.style.animationDuration = `${duration}s`;
		};

		if(document.fonts?.ready) {
			document.fonts.ready.then(setupAnimation);
		} else {
			setupAnimation();
		}

		ticker.addEventListener('mouseenter', () => {
			track.style.animationPlayState = 'paused';
		});

		ticker.addEventListener('mouseleave', () => {
			track.style.animationPlayState = 'running';
		});
	},

	initPageLoader() {
		const dialog = document.getElementById('page-loader');
		if(!dialog) return;

		// Hide when page fully loaded
		const hideLoader = () => {
			dialog.removeAttribute('open');
		};

		if(document.readyState === 'complete') {
			hideLoader();
		} else {
			window.addEventListener('load', hideLoader);
		}

		// Show loader on nav link clicks
		const navPrimary = document.getElementById('nav-primary');
		if(!navPrimary) return;

		navPrimary.addEventListener('click', (e) => {
			const link = e.target.closest('a');
			if(!link) return;

			const href = link.getAttribute('href');

			// Skip if not a page navigation
			if(!href ||
				href === '#' ||
				href.startsWith('#') ||
				link.hasAttribute('data-modal-ajax') ||
				(link.hostname && link.hostname !== window.location.hostname)) {
				return;
			}

			// Show loader
			dialog.setAttribute('open', '');
		});
	},
};
